import { IconComponent } from './types';

const SectionGroupIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M.917.917h10.167v10.167H.917z"
    />
    <path
      fill="currentColor"
      d="M0 0h2v2H0zM0 10h2v2H0zM10 10h2v2h-2zM10 0h2v2h-2z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.5}
      d="M3.917 3.917h10.167v10.167H3.917z"
    />
    <path
      fill="currentColor"
      d="M3 3h2v2H3zM3 13h2v2H3zM13 13h2v2h-2zM13 3h2v2h-2z"
    />
  </svg>
);

export default SectionGroupIcon;
